import { injectStyle } from "./style";
import { h } from "./createElement";
import * as React from 'react';
import classNames from 'classnames';
import './polyfill';
injectStyle("common/global.css", "[data-duim-0-106-4]{-webkit-tap-highlight-color:transparent}");
var ThemeContext = React.createContext(null);
export function consumeTheme(renderProp) {
    return (h(ThemeContext.Consumer, null, function (themeConfig) {
        var classNames = createThemedClassNames(themeConfig);
        return renderProp(classNames);
    }));
}
function appendThemeClassNames(themeConfig, className) {
    if (!className || !themeConfig) {
        return className;
    }
    var currentClassList = className.split(/\s+/);
    var mergedClassList = currentClassList.concat.apply(currentClassList, currentClassList.map(function (name) { return themeConfig[name]; }).filter(function (name) { return name; }));
    return mergedClassList.join(' ');
}
export function createThemedClassNames(themeConfig) {
    return (function () {
        var classes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classes[_i] = arguments[_i];
        }
        return appendThemeClassNames(themeConfig, classNames.apply(void 0, classes));
    });
}
export default ThemeContext;
